module.exports = __webpack_public_path__ + "img/C-Avrej.bbb50651.png";